module.exports = __webpack_public_path__ + "img/paper.c508997a.svg";